export default __webpack_public_path__ + "assets/icons/message_warning_active.f4f50ffb.svg";